import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify';
import { useRegister } from '../../../context/RegisterContext';
import { api } from '../../../services/api';
import { BiUser, BiLockAlt, BiEnvelope, BiPhone, BiCalendar } from 'react-icons/bi'
import { MdVisibility, MdVisibilityOff } from 'react-icons/md'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { BirthdateInput, TelInput } from '../../inputMasks'
import { ModalAcceptTerms } from './modalAcceptTerms';
import moment from 'moment'

import { Container, Header, InputLog, InputContainer, Logo, ButtonsContainer  } from './style';


export function RegisterDatasPersonContent() {
    const { handleFirstPageRegisterData, modalAcceptOpen, handleModalAcceptOpen } = useRegister();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [cpf, setCpf] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [acceptTerms, setAcceptTerms] = useState({ idTerm: '' });

    const [showPassword, setShowPassword] = useState(false);
    const [missingToFillInput, setMissingToFillInput] = useState(false);

    const stringSplit = birthDate.split('')
    const dateFormat = `${stringSplit[6] + stringSplit[7] + stringSplit[8] 
    + stringSplit[9] + '-' + stringSplit[3] 
    + stringSplit[4] + '-' + stringSplit[0] + stringSplit[1]}` 

    const passwordLength = password.split('').length
    

    useEffect(() => {
        api.get('/getTerm').then(response => setAcceptTerms(response.data))
    }, [])
    
    useEffect(() =>{
      if (passwordLength === 10)
        toast.error("Você atingiu o tamanho máximo da senha: 10")
    }, [passwordLength])

    function verifyDate() {
      if( new Date().getFullYear() < parseInt( (stringSplit[6] + stringSplit[7] + stringSplit[8] + stringSplit[9]), 10 ) 
      && new Date().getMonth() + 1 < parseInt( (stringSplit[3] + stringSplit[4]), 10 ) 
      && new Date().getDate() <  parseInt( (stringSplit[0] + stringSplit[1]), 10 ) )
        return true
      else
        return false
    }
    

    async function savePersonData (){
        await handleFirstPageRegisterData({
          name,
          email,
          phoneNumber,
          cpf,
          birthDate: dateFormat,
          password,
          idTerm: acceptTerms.idTerm
        })
      localStorage.setItem('@Inoveclube:userName', name)
      handleModalAcceptOpen()
    }


    return(
        <Container>
            <Header>
              <Link to="/login"><AiOutlineArrowLeft/></Link>
              <h1>Preencha os dados</h1>
            </Header>

            <InputContainer>
              <Logo></Logo> 

              <InputLog alertUserToFillInput={name === '' && missingToFillInput}>
                <BiUser/>
                <input 
                  type="text" 
                  placeholder="Nome completo"
                  value={name.toUpperCase()}
                  maxLength={40}
                  onChange={event => setName(event.target.value)}
                >
                </input>
              </InputLog>

              <InputLog alertUserToFillInput={email === '' && missingToFillInput}>
                <BiEnvelope/>
                <input 
                  type="email" 
                  placeholder="Email"
                  value={email}
                  maxLength={60}
                  onChange={event => setEmail(event.target.value)}
                >
                </input>
              </InputLog>

              <InputLog alertUserToFillInput={phoneNumber === '' && missingToFillInput}>
                <BiPhone/>
                <TelInput 
                  type="tel" 
                  placeholder="Celular"
                  name="TelInput"
                  value={phoneNumber}
                  onChange={event => setPhoneNumber(event.target.value)}
                >
                </TelInput>
              </InputLog>

              <InputLog alertUserToFillInput={cpf === '' && missingToFillInput}>
                <BiUser/>
                <input 
                  type="tel" 
                  placeholder="CPF ou CNPJ"
                  maxLength={14}
                  name="CpfInput"
                  value={cpf}
                  onChange={event => setCpf(event.target.value)}
                />
              </InputLog>

              <InputLog alertUserToFillInput={birthDate === '' && missingToFillInput}>
                <BiCalendar/>
                <BirthdateInput 
                  type="tel" 
                  placeholder="Data de nascimento"
                  name="BirthdateInput"
                  value={birthDate}
                  onChange={event => setBirthDate(event.target.value)}              
                >
                </BirthdateInput>
              </InputLog>

              <InputLog alertUserToFillInput={password === '' && missingToFillInput}>
                <BiLockAlt/>
                <input 
                  type={showPassword ? "text" : "password"}
                  placeholder="Senha"
                  value={password}
                  maxLength={10}
                  onChange={event => setPassword(event.target.value)}
                >
                </input>
                {showPassword ?
                  <MdVisibility onClick={() => setShowPassword(false)} className="visibility"/>
                  :
                  <MdVisibilityOff  onClick={() => setShowPassword(true)} className="visibilityOff"/> 
                }
              </InputLog>
          
              <InputLog alertUserToFillInput={confirmPassword === '' && missingToFillInput}>
                <BiLockAlt/>
                <input 
                  type={showPassword ? "text" : "password"}
                  placeholder="Repita a senha"
                  value={confirmPassword}
                  maxLength={10}
                  onChange={event => setConfirmPassword(event.target.value)}
                >
                </input>
              </InputLog>
             
              <ButtonsContainer>      
                  <button 
                    className="logButton g-recaptcha" 
                    data-sitekey="6LcmFyAcAAAAANYtWCTkXQDnnGB7aVoSAisllMfC" 
                    data-callback="handleSubmit"
                    data-size="invisible"
                    SameSite="secure"
                    onClick={() => { 
                      localStorage.removeItem('@Inoveclube:token')
                      localStorage.removeItem('@Inoveclube:userName')
                      if (name === "" || email === "" || birthDate === "" || password === "" || cpf === "" || confirmPassword === ""){
                        setMissingToFillInput(true)
                        toast.error("Preencha os campos obrigatórios")
                      }

                      else if(  new Date().getFullYear() - parseInt( (stringSplit[6] + stringSplit[7] + stringSplit[8] + stringSplit[9]), 10 ) > 120)
                        toast.error("Insira uma data válida")
                      
                      else if(verifyDate())
                        toast.error("Insira uma data válida")
                      
                      else if(password !== password.replace(/[^\x00-\x7F]/g, ""))
                        toast.error("Não são permitidos caracteres especiais")
                      
                      else if(moment(dateFormat, 'YYYY-MM-DD',true).isValid() === false)
                        toast.error("Insira uma data válida")

                      else if (password !== confirmPassword)
                        toast.error("As senhas não coincidem");

                      else if (passwordLength > 10)
                        toast.error("Tamanho máximo da senha: 10")

                      else
                        handleModalAcceptOpen();
                    } }
                  >
                    CADASTRAR
                  </button> 
              </ButtonsContainer>  
          </InputContainer>
        
        {modalAcceptOpen ?
            <ModalAcceptTerms  handleModalAcceptOpen={handleModalAcceptOpen}  savePersonData={savePersonData} acceptTerms={acceptTerms}/> 
            :<></>
        } 
        </Container>
    )
}
